import Navbar from '@/components/marketplace/Navbar';
import Sidebar from '@/components/marketplace/Sidebar';

const Pulse = ({ className }) => (
  <div className={`animate-pulse bg-slate-200 rounded ${className}`} />
);

export function DashboardSkeleton() {
  return (
    <div className="min-h-screen bg-slate-100" data-testid="dashboard-skeleton">
      <Navbar />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto space-y-8">
            <div>
              <Pulse className="h-4 w-24 mb-2" />
              <Pulse className="h-9 w-72 mb-2" />
              <Pulse className="h-4 w-48" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[1,2,3,4].map(i => (
                <div key={i} className="bg-white rounded-xl p-6 shadow-sm">
                  <Pulse className="h-3 w-24 mb-3" />
                  <Pulse className="h-8 w-16 mb-2" />
                  <Pulse className="h-3 w-32" />
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2 bg-white rounded-xl p-6 shadow-sm">
                <Pulse className="h-5 w-36 mb-4" />
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                  {[1,2,3,4].map(i => (
                    <div key={i} className="text-center p-5 bg-slate-50 rounded-2xl">
                      <Pulse className="h-12 w-12 mx-auto mb-3 rounded-xl" />
                      <Pulse className="h-7 w-10 mx-auto mb-2" />
                      <Pulse className="h-3 w-16 mx-auto" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm space-y-3">
                <Pulse className="h-5 w-28 mb-4" />
                {[1,2,3].map(i => (
                  <div key={i} className="flex items-center gap-4 p-3">
                    <Pulse className="h-12 w-12 rounded-xl shrink-0" />
                    <div className="flex-1">
                      <Pulse className="h-4 w-28 mb-2" />
                      <Pulse className="h-3 w-36" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export function ListPageSkeleton({ title = 'Loading...' }) {
  return (
    <div className="min-h-screen bg-slate-100" data-testid="list-skeleton">
      <Navbar />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto space-y-6">
            <div>
              <Pulse className="h-4 w-20 mb-2" />
              <Pulse className="h-8 w-48 mb-2" />
              <Pulse className="h-4 w-64" />
            </div>
            <div className="flex gap-3">
              <Pulse className="h-10 w-64 rounded-xl" />
              <Pulse className="h-10 w-32 rounded-xl" />
              <Pulse className="h-10 w-32 rounded-xl" />
            </div>
            <div className="space-y-3">
              {[1,2,3,4,5].map(i => (
                <div key={i} className="bg-white rounded-xl p-5 shadow-sm">
                  <div className="flex items-center gap-4">
                    <Pulse className="h-11 w-11 rounded-xl shrink-0" />
                    <div className="flex-1">
                      <Pulse className="h-4 w-48 mb-2" />
                      <Pulse className="h-3 w-72" />
                    </div>
                    <Pulse className="h-6 w-20 rounded-full" />
                    <Pulse className="h-5 w-24" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
